import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { DISTANCE_MEASUREMENT_EXTRA_SMALL } from 'HubStyleTokens/sizes';
import { remCalc } from 'UIComponents/core/Style';
import { View } from 'foundations-components/components/View';
import { ROW_BREAKPOINT } from '../../constants/Sizes';
import useWindowSize from '../../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
const MARGIN = parseInt(DISTANCE_MEASUREMENT_EXTRA_SMALL, 10) / 2;
// Based on FullNameInput implementation
// https://git.hubteam.com/HubSpot/ui-addon-i18n/blob/master/static/js/components/FullNameInput.js
const ResponsiveInputWrapper = ({
  children,
  fixedRow = false
}) => {
  const {
    width
  } = useWindowSize();
  const isRow = fixedRow || width >= ROW_BREAKPOINT;
  const direction = isRow ? 'row' : 'column';
  const wrapBoxStyle = isRow ? {
    margin: remCalc(MARGIN.toString())
  } : undefined;
  const flexBoxStyle = isRow ? {
    margin: remCalc((MARGIN * -1).toString())
  } : undefined;
  const viewMarginInlineEnd = isRow ? '-200' : undefined;
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: viewMarginInlineEnd,
    children: /*#__PURE__*/_jsx(UIFlex, {
      direction: direction,
      align: "stretch",
      style: flexBoxStyle,
      children: children.map((element, index) => /*#__PURE__*/_jsx(UIBox, {
        grow: 1,
        shrink: 1,
        basis: "0",
        style: wrapBoxStyle,
        children: element
      }, index))
    })
  });
};
export default ResponsiveInputWrapper;